import * as React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import HomePage from "./components/HomePage.react";
import Settings from "./components/Settings.react";
import NewQR from "./components/NewQR.react";
import Login from "./components/LoginPage.react";
import SiteWrapper from "./SiteWrapper.react";
import Subscriptions from "./components/Subscriptions.react";
import TeamPermissions from "./components/TeamPermissions.react";
import AllInvoices from "./components/AllInvoices.react";

type Props = {||};

function App(props: Props): React.Node {
  return (
    <React.StrictMode>
        <Router>
            <Switch>
                <Route exact path="/login" component={Login} />
                <SiteWrapper>
                    <Switch>
                        <Route exact path="/settings" component={Settings} />
                        <Route exact path="/dashboard" component={HomePage} />
                        <Route exact path="/new-qr" component={NewQR} />
                        <Route exact path="/subscriptions" component={Subscriptions} />
                        <Route exact path="/team" component={TeamPermissions} />
                        <Route exact path="/all-invoices" component={AllInvoices} />
                        <Redirect exact from='/' to='/dashboard' />
                    </Switch>
                </SiteWrapper>
                <Redirect from='*' to='/dashboard' />
            </Switch>
      </Router>
    </React.StrictMode>
  );
}

export default App;
